import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { BillableCustomerOrdersDataGrid } from "src/components/views/erp/sales/invoicing/customerOrderInvoicing/BillableCustomerOrdersDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/sales/invoicing/billableCustomerOrders")({
	staticData: { title: i18n.t("billable_customer_orders"), legacyViewKey: "billableCustomerOrdersPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <BillableCustomerOrdersDataGrid />;
}
